import React from "react";
import { useCurrencyFormatter } from "../../hooks/useCurrencyFormatter";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import {
  formatInterestRate,
  formatTermLength,
  formatMonthlyPayment,
  getMonthlyPaymentTooltip,
} from "./metricHelpers";

export default function DefaultSecondaryMetric({ sim }: MetricComponentProps) {
  const c = useCurrencyFormatter();

  return (
    <>
      <MetricItem
        value={formatInterestRate(sim)}
        tooltip="Mortgage Interest Rate"
      />
      {" • "}
      <MetricItem value={formatTermLength(sim)} tooltip="Mortgage Term" />
      {" • "}
      <MetricItem
        value={formatMonthlyPayment(sim, c)}
        tooltip={getMonthlyPaymentTooltip(sim)}
      />
    </>
  );
}
